module.exports = __webpack_public_path__ + "img/card1.d3dab642.png";